(function () {
  // Olas: the theme editor fires shopify:section:load/unload/reorder for every section, and each
  // event re-runs initAnnBar. The observers used to live inside initAnnBar, so every run created a
  // new pair while the previous pair (possibly on a detached bar) kept running and could reset
  // --ann-height to 0px after the new pair had set it. They now live at module level and are
  // disconnected before each re-init; the document listeners are registered once even if the
  // script is evaluated again. Storefront behaviour (continuous visible-height tracking) is unchanged.
  if (window.olasAnnBarLifecycle) return;
  window.olasAnnBarLifecycle = true;

  let intersectionObserver;
  let resizeObserver;

  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");

    let lastRatio = 1;

    const updateHeight = (intersectionRatio = 1) => {
      const annBarHeight = annBar?.getBoundingClientRect().height || 0;
      const effectiveHeight = (annBarHeight * intersectionRatio).toFixed(2);
      document.documentElement.style.setProperty(
        "--ann-height",
        `${effectiveHeight}px`
      );
    };

    const createObservers = () => {
      if (intersectionObserver) intersectionObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();

      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updateHeight(entry.intersectionRatio);
              lastRatio = entry.intersectionRatio;
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
              lastRatio = 0;
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      resizeObserver = new ResizeObserver(() => {
        updateHeight(lastRatio);
      });

      if (annBar) intersectionObserver.observe(annBar);
      if (annBar) resizeObserver.observe(annBar);
    };

    createObservers();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
